@if (data()) {

  <table [dataSource]="items" mat-table matSort>
    <!-- A bunch of columns just used for first column -->
    <ng-container matColumnDef="day">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell> {{ item.day }}</td>
    </ng-container>
    <ng-container matColumnDef="weekday">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell> {{ item.weekday }}</td>
    </ng-container>
    <ng-container matColumnDef="week">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell>{{ item.week }}</td>
    </ng-container>
    <ng-container matColumnDef="month">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell>{{ item.month }}</td>
    </ng-container>
    <ng-container matColumnDef="year">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell>{{ item.year }}</td>
    </ng-container>
    <ng-container matColumnDef="all">
      <th *matHeaderCellDef mat-header-cell>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell>{{ item.year }}</td>
    </ng-container>
    <ng-container matColumnDef="age">
      <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell style="white-space: nowrap">{{ item.age }}</td>
    </ng-container>
    <ng-container matColumnDef="sex">
      <th *matHeaderCellDef mat-header-cell>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell style="white-space: nowrap">
        @if (item.key === 'FF') {
          <span>&#9792; - &#9792;</span>
        }
        @if (item.key === 'MF') {
          <span>&#9794; - &#9792;</span>
        }
        @if (item.key === 'FM') {
          <span>&#9792; - &#9794;</span>
        }
        @if (item.key === 'MM') {
          <span>&#9794; - &#9794;</span>
        }
        @if (item.key === 'M') {
          <span>&#9794;</span>
        }
        @if (item.key === 'F') {
          <span>&#9792;</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="risk">
      <th *matHeaderCellDef mat-header-cell>{{ rangeTitle }}</th>
      <td *matCellDef="let item" mat-cell style="white-space: nowrap">{{ item.risk }}</td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Ansökningar
      </th>
      <td *matCellDef="let item" mat-cell>
        <div style="text-align: end">
          {{ item.total }}
        </div>
      </td>

    </ng-container>

    <!-- From here  we have value columns

     -->
    <ng-container matColumnDef="auto_total">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Automatiserade
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.total - item.pending"
          [percent]="item.quotas.auto"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="approved">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Godkända
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.approved"
          [percent]="item.quotas.approved"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="rejected">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Avslag
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.rejected"
          [percent]="item.quotas.rejected"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="pending">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Handläggare
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.pending"
          [percent]="item.quotas.pending"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="declined">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Avböjt
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.declined"
          [percent]="item.quotas.declined"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="superfast">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Supersnabb
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.superfast"
          [percent]="item.quotas.superfast"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="uc">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Avslag UC
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.uc"
          [percent]="item.quotas.uc"
        />
      </td>
    </ng-container>
    <ng-container matColumnDef="kalp">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Avslag KALP
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.kalp"
          [percent]="item.quotas.kalp"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="income">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Avslag Inkomst
      </th>
      <td *matCellDef="let item" mat-cell>
        <spb-value
          [hidePercent]="hidePercent()"
          [value]="item.income"
          [percent]="item.quotas.income"
        />
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th *matHeaderCellDef class="header-number" mat-header-cell>
        Beviljat
      </th>
      <td *matCellDef="let item"
          mat-cell>
        <div class="number">
          {{ item.amounts.approved | number:'1.0-0':'sv' }}
        </div>
      </td>
    </ng-container>
    <tr *matHeaderRowDef="columns()" mat-header-row></tr>
    <tr *matRowDef="let row; columns: columns()" mat-row></tr>
  </table>

  <mat-checkbox (change)="getTotal($event.checked, 'percent')"
                [checked]="hidePercent()">Dölj procent
  </mat-checkbox>

}
